class ComponentIngredients extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.search = this.querySelector('[data-search]');
    this.headlines = this.querySelectorAll('[data-headline]');
    this.entries = this.querySelectorAll('[data-filter-entry]');
    this.filters = this.querySelectorAll('button[data-filter]');
    this.filters.forEach((filter) =>
      filter.addEventListener('click', this.handleOnFilterClick.bind(this))
    );
    this.search.addEventListener('keyup', this.handleOnSearchChange.bind(this));
  }

  handleOnFilterClick(event) {
    this.setActiveFilter(event.target);
    this.setActiveEntries(event.target.dataset.filter);
  }

  handleOnSearchChange(event) {
    this.classList.toggle('is-filtered', event.target.value !== '');

    if (event.target.value === '') {
      return this.entries.forEach((entry) => entry.classList.remove('hidden'));
    }

    this.entries.forEach((entry) =>
      entry.classList.toggle(
        'hidden',
        !(
          entry.dataset.title.includes(event.target.value.toLowerCase()) ||
          entry.dataset.body.includes(event.target.value.toLowerCase()) ||
          entry.dataset.shortDescription.includes(
            event.target.value.toLowerCase()
          )
        )
      )
    );
  }

  setActiveFilter(element) {
    this.filters.forEach((filter) =>
      filter.classList.toggle('is-active', element === filter)
    );
  }

  setActiveEntries(value) {
    this.classList.toggle('is-filtered', value !== 'all');

    if (value === 'all') {
      return this.entries.forEach((entry) => entry.classList.remove('hidden'));
    }

    this.entries.forEach((entry) =>
      entry.classList.toggle(
        'hidden',
        !entry.dataset.filterValues.includes(value)
      )
    );
  }
}

customElements.define('component-ingredients', ComponentIngredients);
